import './lib/staticApi'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'

import App from './App'
import { loadColormaps } from './components/Legend'
import './index.css'
import { applyTokens } from './design/tokens'

applyTokens()

const container = document.getElementById('root')
if (!container) {
  throw new Error('#root is missing from index.html')
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Run artefacts are immutable once a run is done, so refetching on every
      // window focus would re-download a 97-frame animation for nothing. The
      // run LIST sets its own refetchInterval, because that does change.
      refetchOnWindowFocus: false,
      staleTime: 60_000,
      retry: 1,
      // The API is on this machine. React Query's default pauses every fetch while the
      // browser reports itself offline, which froze the 3-D playback mid-run whenever the
      // laptop's network dropped, though 127.0.0.1 was answering throughout.
      networkMode: 'always' as const,
    },
  },
})

// The colour ramps come from the backend's single definition before anything draws.
void loadColormaps()
  .catch((error) => console.error(error))
  .finally(() => render())

function render() {
ReactDOM.createRoot(container as HTMLElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)
}
